const arrowDown = document.querySelectorAll('.arrowDown');

if (arrowDown.length > 0){
    arrowDown.forEach(arrowDown => {
        arrowDown.addEventListener('click', function(event){
           let selectedDiv = document.querySelector('.ce_rsce_slideshow').nextElementSibling;
            
            selectedDiv.scrollIntoView({ behavior: 'smooth' });
            
        })
    })
}